import { IMAGES } from "@/data/siteData";
import { Check } from "lucide-react";

const highlights = [
  "Specializzazione in Gastroenterologia",
  "Esperienza ospedaliera e libero-professionale",
  "Partecipazione a congressi nazionali e internazionali",
  "Attività di ricerca clinica e pubblicazioni",
  "Medicina basata sull'evidenza scientifica",
];

export default function ChiSono() {
  return (
    <section id="chi-sono" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div className="relative">
            <div className="absolute -inset-2 bg-gradient-to-br from-[#C6A86B]/10 to-transparent rounded-2xl blur-2xl" />
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(11,74,90,0.12)]">
              <img
                src={IMAGES.aboutDoctor}
                alt="Dr. Cristian Santus"
                className="w-full h-[520px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute bottom-6 left-6 right-6 md:bottom-8 md:left-8 md:right-8 bg-white/85 backdrop-blur-md rounded-xl p-5 border border-white/40 shadow-md">
              <p className="text-[11px] uppercase tracking-[0.2em] text-[#C6A86B]">
                Dott.
              </p>
              <p className="font-serif text-xl text-[#0B4A5A] mt-1">
                Cristian Santus
              </p>
              <p className="text-sm text-gray-600">Gastroenterologo</p>
            </div>
          </div>

          <div>
            <p className="overline">Chi sono</p>
            <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
              Ascolto, competenza e medicina delle evidenze.
            </h2>
            <div className="gold-line mt-8 w-16" />
            <p className="mt-8 text-gray-700 leading-relaxed text-[17px]">
              Mi occupo della diagnosi e del trattamento delle malattie
              dell'apparato digerente con particolare attenzione alla medicina
              basata sulle evidenze scientifiche e alla relazione medico-paziente.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed">
              Ogni percorso di cura nasce dall'ascolto, prosegue con una diagnosi
              accurata e si conclude con un piano terapeutico condiviso.
            </p>

            <ul className="mt-10 space-y-3">
              {highlights.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#C6A86B]/15 text-[#C6A86B] flex items-center justify-center flex-shrink-0">
                    <Check size={12} strokeWidth={2.2} />
                  </span>
                  <span className="text-gray-700 text-[15px]">{h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
